import * as React from "react";
import * as ReactDOM from "react-dom";
import classnames from "classnames";
import * as styles from "./styles.scss";
import { Html } from "../../../../components";
import { tl } from "../../../../utils";

interface ISelectProps {
  value: any;
}

const renderSelect = (props: any, i: any) => (
  <div className={styles.option} key={i}>
    <span className={styles.answer}>{tl("Ответ")}.</span>
    <pre className={styles.pre}>
      <Html>{props.option}</Html>
    </pre>
  </div>
);

export const Select = ({ value }: ISelectProps) => (
  <div>{value.map(renderSelect)}</div>
);